
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12.24 1.6a1.04 1.04 0 00-1.04 1.04V13.6H9.6V6.64A1.04 1.04 0 008.56 5.6H7.44A1.04 1.04 0 006.4 6.64v6.96H4.8V9.04A1.04 1.04 0 003.76 8H2.64A1.04 1.04 0 001.6 9.04v4.56h-.4a.4.4 0 000 .8h13.6a.4.4 0 000-.8h-.4V2.64a1.04 1.04 0 00-1.04-1.04h-1.12zm1.36 12V2.64a.24.24 0 00-.24-.24h-1.12a.24.24 0 00-.24.24V13.6h1.6zM8.8 6.64v6.96H7.2V6.64a.24.24 0 01.24-.24h1.12a.24.24 0 01.24.24zM4 13.6V9.04a.24.24 0 00-.24-.24H2.64a.24.24 0 00-.24.24v4.56H4z","fill":"currentColor"}})])
          )
        }
      }
    